import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function resultsSearchTermReducer(
  state = initialState.resultsViewSearchTerm,
  action
) {
  //updating the state basing on action data
  switch (action.type) {
    case types.SET_RESULTSPAGE_SEARCHTERM:
      return action.data;
    default:
      return state;
  }
}
